export default["__VITE_ASSET__BQP9WTCw__","__VITE_ASSET__$r4lu0PS__"];